export default {
  DEFAULT_LOCALE: process.env.NEXT_PUBLIC_DEFAULT_LOCALE || 'nl',
  HOST: process.env.NEXT_PUBLIC_HOST || 'zwangerenportaal.nl',
  GRAPHQL_URL: process.env.NEXT_PUBLIC_GRAPHQL_URL || 'https://core.zwangerenportaal.nl/graphql',
  AUTH_URL: process.env.NEXT_PUBLIC_AUTH_URL || 'https://id.zwangerenportaal.nl/auth',
  LOGIN_URL: process.env.NEXT_PUBLIC_LOGIN_URL || 'https://id.zwangerenportaal.nl/login',
  SIGNUP_URL: process.env.NEXT_PUBLIC_SIGNUP_URL || 'https://id.zwangerenportaal.nl/signup',
  PASSWORD_RESET_URL: process.env.NEXT_PUBLIC_PASSWORD_RESET_URL || 'https://id.zwangerenportaal.nl/password-reset',
  RETRIEVE_USERNAME_URL: process.env.NEXT_PUBLIC_RETRIEVE_USERNAME_URL || 'https://id.zwangerenportaal.nl/retrieve-username',
  LOGOUT_URL: process.env.NEXT_PUBLIC_LOGOUT_URL || 'https://id.zwangerenportaal.nl/logout',
  PLAZA_VOUCHERS_URL: process.env.NEXT_PUBLIC_PLAZA_VOUCHERS_URL || 'https://vouchers.zwangerenportaal.nl',
  COMMUNITY_URL: process.env.NEXT_PUBLIC_COMMUNITY_URL || 'https://community.24baby.nl'
};
